import { default as List } from './DealershipList';
import { default as View } from './DealershipView';
export default {
	List,
	View
};
